import moment from 'moment';

export default function date(value, utc = false) {
  if (value) {
    if (utc) return moment(String(value)).utc().format('DD/MM/YYYY');

    return moment(String(value)).format('DD/MM/YYYY');
  }

  return value;
}
